import React from 'react';
import ReactDOM from 'react-dom';
import DrawerMenuToggleButton from './DrawerMenuToggleButton';

const DrawerMenu: React.FC = () => {
  const drawer_contents = [];

  // 最終ログインのnodeを取得する
  const node_header = document.getElementsByClassName('login-info')[0] ?? null;
  const node_last_login =
    node_header !== null && typeof node_header !== 'undefined'
      ? node_header.getElementsByTagName('p')[0]
      : null;
  // ログインユーザのnodeを取得する
  const node_user =
    node_header !== null && typeof node_header !== 'undefined'
      ? node_header.getElementsByTagName('p')[1]
      : null;

  // nodeが存在しているならspanで括ってコンテンツに追加する
  if (node_last_login !== null && typeof node_last_login !== 'undefined') {
    drawer_contents.push(
      <span>{node_last_login !== null ? node_last_login.innerHTML : null}</span>
    );
  }
  // nodeが存在しているならspanで括ってコンテンツに追加する
  if (node_user !== null && typeof node_user !== 'undefined') {
    drawer_contents.push(<span>{node_user !== null ? node_user.innerHTML : null}</span>);
  }

  // ログアウト
  const handleClickLogout = (event: React.MouseEvent) => {
    event.preventDefault();
    // ヘッダー部のnodeを取得する
    const node_sticky_top = document.getElementsByClassName('sticky-top');
    // formのnodeを探索する
    const logout =
      node_sticky_top !== null ? node_sticky_top[0].getElementsByTagName('form')[0] : null;

    if (logout !== null && typeof logout !== 'undefined') {
      logout.submit();
    }
  };
  // ログアウトのnodeを取得する
  const node_logout = document.getElementById('logout-form');
  if (node_logout !== null && typeof node_logout !== 'undefined') {
    // ボタン要素を探索する
    const logout_button = node_logout.getElementsByTagName('button');
    const button_name = logout_button[0].innerText;

    // ログアウトボタンを生成する
    drawer_contents.push(
      <a href="#" onClick={handleClickLogout}>
        {button_name}
      </a>
    );
  }

  // システムリンク
  // system-linkのnodeを取得する
  const node_system_link = document.getElementsByClassName('system-link')[0] ?? null;
  const node_links = node_system_link !== null ? node_system_link.getElementsByTagName('a') : null;
  if (node_links !== null) {
    const collection = Array.from(node_links); // HTMLCollectionを配列化
    collection.map((html, index) => {
      const href = html.getAttribute('href') ?? undefined; // NOTE hrefの期待している型がstring | undefinedのため
      // system-link各リンクのボタンを生成する
      drawer_contents.push(
        <a href={href} key={index}>
          {html.innerHTML}
        </a>
      );
    });
  }

  return (
    <div id="drawer-menu-body" className="hidden">
      <div id="drawer-overlay"></div>
      <div id="drawer-body">
        <div className="toggle-button text-right">
          <DrawerMenuToggleButton />
        </div>
        <ul id="drawer-links">
          {drawer_contents.map((row, index) => (
            <li key={index}>{row}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

if (document.getElementById('drawer-menu-contents')) {
  ReactDOM.render(<DrawerMenu />, document.getElementById('drawer-menu-contents'));
}
